// @flow
import {selectIntlTranslationList, withTranslationGroup} from '@userstory/i18n';
import {ROUTE} from 'app/constants/route';
import {AnonymousHeader} from 'modules/common/components/AnonymousHeader';
import {Button} from 'modules/common/components/Button';
import {FullLoader} from 'modules/common/components/FullLoader';
import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import style from './styles.local.less';

/**
 * Страница неверной ссылки верификации мейла
 * @return {JSX.Element} страница
 * @constructor
 */
const NewEmailExpiredPage = withTranslationGroup({groupLists: ['common']})(() => {
    if (0 === Object.keys(useSelector(selectIntlTranslationList)).length) {
        return <FullLoader />;
    }

    const intl = useIntl();
    const history = useHistory();

    /**
     * Редирект на страницу входа
     */
    function handleButton() {
        history.push(`/${ROUTE.AUTH}/sign-in`);
    }

    return (
        <>
            <AnonymousHeader />
            <div className={style.content}>
                <h1 className={style.title}>{intl.formatMessage({defaultMessage: 'Ссылка недействительна', id: 'common.emailLinkExpired'})}</h1>
                <h2 className={style.description}>
                    {intl.formatMessage({
                        defaultMessage: 'Срок действия ссылки истек. Для продолжения, пожалуйста, войдите в личный кабинет.',
                        id: 'common.emailLinkUseOldEmail',
                    })}
                </h2>
                <Button className={style.button} onClick={handleButton}>
                    {intl.formatMessage({defaultMessage: 'Авторизоваться', id: 'common.authorize'})}
                </Button>
            </div>
        </>
    );
});

export {NewEmailExpiredPage};
